import {createContext, useEffect} from "react";

export const FormContext = createContext({});

export function SimpleForm({ children, formulario, onChange }) {
    const { values, getValue, setValue } = formulario;

    let form = {
        value: getValue,
        setValue,
    };

    useEffect(() => {
        if (onChange) {
            onChange(values);
        }
    }, [values]);

    return (
        <FormContext.Provider value={form}>
            <form className='form-reporte'>{children}</form>
        </FormContext.Provider>
    );
}
